import React from 'react';

export const HtmlBlock = ({html}) => {

    const getHtml = (html)  => {
        return {__html: html};
    };
    return <div dangerouslySetInnerHTML={getHtml(html)}></div>
};
